import React from "react";
import "./About.scss";
import { Heart, Briefcase, Stethoscope, Star, Calendar, Globe } from "lucide-react";
import Footer from "../components/Footer/Footer";

export default function About() {
  return (
    <div className="about-container">
      {/* Hero / Intro */}
      <div className="about-content">
      <section className="about-hero">
        <h1 className="textt">Know About</h1>
        <p>
          When you’re asked “what’s your sign?” the most basic answer is one of the 12 zodiac signs the sun was in when you were born. But that’s just one tiny detail in a much larger, heavily layered, complicated, individual picture that illustrates your very own astrological story. We, professional astrologers, look at a whole chart, which you can think of as a snapshot of the sky when you were born – based on not only the month and day but the year, time, and place of your birth. This means even two people born on the same exact month, day, and year, but at different times and in different locations, will have their own unique chart. That’s because all the celestial bodies move at different rates through the signs.We can use this movement of planets to explain the current event like marriage or election,social trends, financial market.Our moto is to understand the key building blocks of astrology to improve your self awareness and give a proper direction to your physical, mental, emotional and financial life and connect yoy with the “Science of the Mother of all Sciences ”
        </p>
        <button className="call-btn">+91-9382481286</button>
      </section>

      {/* Services breakdown */}
      <section className="services">
        <h2 className="textt">Facing struggles in life?</h2>
        <div className="service-card">
          <Heart className="icon" /><h3>Love & Harmony</h3>
          <p>Facing relationship struggle? OR Simply trying to change your life in small ways? Having stressful relationship? Astro Punam Agarwala have available many strategies to help you to provide you the best version of your love life.</p>
        </div>
        <div className="service-card">
          <Stethoscope className="icon" /><h3>Health & Wellness</h3>
          <p>Going through health issues?Finding yourself in a unsolved loop of hospitals, medicines,and doctors .Divya Jyotisa will help you to come out from this.It is never too late to pick up a habit that can improve your well being for the rest of your life.</p>
        </div>
        <div className="service-card">
          <Briefcase className="icon" /><h3>Success & Wealth</h3>
          <p>Doing lots of efforts. But not gaining the goals you want to achieve. Divya Jyotisa is here with you. We are all works in progress. And it takes effort and dedication to grow and evolve in a positive direction. Fortunately, there is never a bad time to set new goals for yourself, and it’s never to late to pick up a success habit.We guide you till you achieve your goals and success.</p>
        </div>
        <div className="service-card">
          <Star className="icon" /><h3>Spiritual Growth</h3>
          <p>Astrology provides Cosmic clues as to why you are attracted to, repelled by or indifferent to those you meet.Some connections are sparked by friction, and Astrology helps you take the long view, and see them as challenges that cause you both to grow. Divya Jyotisa guides the path needs for your Spiritual Growth</p>
        </div>
        <div className="service-card">
          <Calendar className="icon" /><h3>Career and Job</h3>
          <p> Trying hard but far away from job as per your ability whether it’s Government or Private . It is time to keep aside all your worries as Divya Jyotisa shows you the best way for you and give your life a proper direction in your career path.</p>
        </div>



        <section>
            <div className="more-info">
                <div className="info-card">
                    <h2 className="textt">Our Moto</h2>
                    <p>Divya Jyotisa believes in serving the humanity through astrological potential and to reveal the known unknown to you. Astrology It falls more in the category of metaphysics, the study of that which is beyond the physical. It’s similar to other fields that are founded on ancient theories of energy patterns, like feng shui, acupuncture, and yoga. Astrology at high levels is a mastery of its particular science and the intuitive arts. As the earliest known ordering of existence, long before recorded history, it’s been called the “Mother of all Sciences.”</p>
                </div>
                <div className="info-card">
                    <h2 className="textt">Our Belief</h2>
                    <p>Many Rishis, like Vashistha, Bhrigu, and Garga, mastered astrology and taught it orally. Before Kaliyuga began in 3102 B.C., Sage Parasara distilled Vedic astrology’s essence into the Brihat Parasara Hora Sastra, which he imparted to his disciple Maitreya. This knowledge was passed down orally through generations. Renowned figures like Chanakya, Aryabhatta, and Brahmagupta were blessed with astrology’s wisdom. Divya Jyotisa believes that if these legendary sages trusted astrology’s power, so should we. Astrology posits that planetary movements influence time, and our birth moment holds significant celestial meaning.</p>
                </div>
            </div>
        </section>
       
      </section>

      {/* Testimonials */}
       <h2 className="textt">What Our Clients Say ?</h2>
       <p className="t"> Testimonials from satisfied clients who experienced positive transformations through our accurate astrology readings and guidance.</p>
      <section className="testimonials">
       
        <div className="testimonial-card">
            <img src="https://asthaddestiny.com/wp-content/uploads/2024/07/WhatsApp-Image-2023-03-30-at-20.46.33.jpeg" alt="" />
          <h3 className="name">Harsha</h3>
          <p className="role">Astrologer</p>
          <p>⭐⭐⭐⭐⭐</p>
          <p>
            “Your kind nature helped me be open to your guidance… I gained clarity in 
            my career path and feel truly blessed to have connected with you.”  
          </p>
        </div>
        <div className="testimonial-card">
            <img src="https://asthaddestiny.com/wp-content/uploads/2024/07/WhatsApp-Image-2023-03-30-at-20.47.09.jpeg" alt="" />
          <h3 className="name">Anita Singhal</h3>
          <p className="role">Astrologer</p>
          <p>⭐⭐⭐⭐⭐</p>
          <p>
            “Just had an amazing reading… We blended astrology and channeling—it was 
            a powerful, unforgettable experience!”  
          </p>
        </div>
      </section>
    </div>
    <Footer/>
    </div>
  );
}
